var map = {
	"./IMG_0796.jpg": 3193,
	"./IMG_0802.jpg": 5441,
	"./IMG_0811.jpg": 2369,
	"./IMG_1378.jpg": 98,
	"./IMG_1388.jpg": 8011,
	"./IMG_1389.jpg": 7854,
	"./IMG_1391.jpg": 5969,
	"./IMG_1392.jpg": 8198
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5444;